"use client";

import * as React from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function FreeHeatPumpAssessment() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="232537" id="free-heat-pump-assessment" className="w-full bg-background text-foreground py-24 md:py-32 lg:py-40">
      <div className="container mx-auto px-4 md:px-6">
        <div ref={ref} className={`flex flex-col items-center text-center space-y-8 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <div className="space-y-4 max-w-3xl">
            <h1 className="text-4xl font-bold tracking-tighter sm:text-5xl md:text-6xl lg:text-7xl font-default text-primary">
              Ready to switch to sustainable heating?
            </h1>
            <p className="mx-auto max-w-[42rem] leading-normal text-muted-foreground sm:text-xl sm:leading-8 font-sans">
              Get a comprehensive site assessment from our SEAI experts. We provide professional guidance to help you transition to efficient, eco-friendly heat pump technology.
            </p>
          </div>
          
          <div className="flex flex-col gap-4 w-full max-w-xs sm:max-w-sm">
            <Button asChild size="lg" className="w-full bg-primary hover:bg-primary/90 text-primary-foreground shadow-lg rounded-md transition-all duration-300">
              <Link to="tel:+35319081819">
                Call for Free Assessment
                <ArrowRight className="ml-2 size-4" />
              </Link>
            </Button>
            <Button asChild variant="outline" size="lg" className="w-full border-primary text-primary hover:bg-accent rounded-md transition-all duration-300">
              <Link to="/HeatPumpsPage">
                View Past Installs
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}